module.exports = (__parcel__import__("j0X24")).then(() => parcelRequire('fyWP3'));